/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $Container, $SetVisibility, CanBeSignals} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core/fragments/store/Store';
import {ReelsSpeedLevel} from '@gongxigames/framework/slotV2/types';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {$BottomPanelPortrait} from './BottomPanelPortrait';
import {$BottomPanelLandscape} from './BottomPanelLandscape';
import {$TopPanelPortrait} from './TopPanel';
import {$WinAreaPortrait} from './WinArea/WinAreaPortrait';

export type PropsCallBack = () => void;

export type UIMainScreenUiProps = CanBeSignals<{
    win: number;
    balance: number;
    betCurrent: number;
    betFormatted: string;
    betList: number[];
    bottomPanelOffset: number;

    // onBetChange: BetSelectOnChange;
    soundEnabled: boolean;
    turboLevel: ReelsSpeedLevel;
    showAutoSpinButton: boolean;
    showAutoSpinOnButton: boolean;
    showTurboModeButton: boolean;
}>;

export const $UIMainScreenUi: FC<UIMainScreenUiProps> = (props) => {
    const selector = Store.computed(() => {
        if (slotStore.stage_isPortrait.value) {
            return ['bottom_panel_portrait', 'top_panel_portrait', 'win_portrait', 'win_area_portrait'];
        }

        return ['bottom_panel_landscape'];
    });

    return <$Container name='main_screen'>
        <$SetVisibility selector={selector}>
            <$TopPanelPortrait {...props}/>
            <$BottomPanelPortrait {...props}/>
            <$BottomPanelLandscape {...props}/>
            <$WinAreaPortrait/>
        </$SetVisibility>
    </$Container>;
};